import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const deleteAbstractProgramOperation = async (
  abstractProgramId: number,
  setAbstractProgramIdLoading: (programId: number | null) => any,
) => {
  try {
    setAbstractProgramIdLoading(abstractProgramId);
    const res = await appApi.deleteAbstractProgram(abstractProgramId);
    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }
    setAbstractProgramIdLoading(null);
  } catch (e) {
    setAbstractProgramIdLoading(null);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
